import { useEffect } from 'react';

interface UseKeyboardInputOptions {
  onDigit: (digit: number) => void;
  onDelete: () => void;
  onSubmit: () => void;
  disabled?: boolean;
}

export function useKeyboardInput({ onDigit, onDelete, onSubmit, disabled = false }: UseKeyboardInputOptions): void {
  useEffect(() => {
    if (disabled) {
      return;
    }

    function handleKeyDown(event: KeyboardEvent): void {
      if (event.key >= '0' && event.key <= '9') {
        event.preventDefault();
        onDigit(parseInt(event.key, 10));
      } else if (event.key === 'Backspace') {
        event.preventDefault();
        onDelete();
      } else if (event.key === 'Enter') {
        event.preventDefault();
        onSubmit();
      }
    }

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onDigit, onDelete, onSubmit, disabled]);
}
